const releasesValidationEN = {
    "add": {
        "releaseName": {
            "required": 'The release name is required',
            "length": 'The release name must be more than 2 and less than 120 characters long',
            "noForwardSlash": 'The release name must not have any farward slash (/)',
            "matchTrack": 'For a one-song release the Release Name should match with the track.',
            // validCharacters: 'The release name can only consist of alphabetical, number, space and underscore',
        },
        "releaseVersion": {
            "length": 'The release version must be more than 2 and less than 120 characters long',
            "validCharacters": 'The release version can only consist of alphabetical, number, space and underscore',
            "missingOne": 'Your release consists of only one track which is not an Original Mix, therefore the custom track mix name must be inserted in the Release Version.',
            "missingTwo": 'If a release offers more content than the standard version or it is another version of already released album/release you need to insert the Release Version.',
            "invalid": 'For a one-song release with no Mix Name (Original Mix), the Release Version should be left empty. Please either clear the Release Version or add a Mix Name to the song.',
        },
        "releaseLanguage": {
            "required": 'Release Language is required. Please select the language of your release name.',
        },
        "releaseEAN_UPC": {
            "required": 'EAN / UPC is required.',
            "length": "The EAN number must be equal to 13 characters",
            "isValidEAN": "The value is not valid EAN. If you are inserting a new release, please insert a proper EAN. If you are uploading a back catalog and EAN is not valid, please contact us.",
        },
        "releaseLabel": {
            "required": 'Please select your label.',
        },
        "releaseCopyright": {
            "required": 'You have to type Copyright Owner. Usually it is your label.',
        },
        "releaseCopyrightYear": {
            "required": 'Please type the copyright year in which this release will be (was) published.',
            "regexp": 'Please type the valid copyright year',
        },
        "releaseCopyrightPublisher": {
            "required": 'You have to type Publisher Owner. Usually it is your label.',
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Please type the copyright year in which this release will be (was) published.',
            "regexp": 'Please type the valid copyright year',
        },
        "releaseGenre": {
            "required": 'Please select your release Genre.',
        },
        "releaseSubGenre": {
            "required": 'Please select your release Sub-Genre',
        },
        "releaseCatalogNumber": {
            "required": 'Insert unique release catalog number.',
            "length": 'Minimum 4 and Maximum 16 characters.',
            "validFormat": 'Please insert your category number without spaces, only CAPITAL letters and numbers. First two characters are required to be CAPITAL letters. MM001, MMD001, MM0001 ... ',
        },
        "releaseDescription": {
            // required: 'A good and professional release description can make a difference.',
            "length": 'A release description has to be at least 100 and maximum 600 characters long. ',
        },
        "releaseArtwork": {
            "required": 'The artwork is required',
            "wrongSpecsAndColor": 'Wrong image specifications and color format. The release cover size has to be exactly 3000 x 3000 px, RGB Colours, JPG, Max file size 4 MB.',
            "wrongColorFormat": 'Wrong image colour format. The release cover has to be in RGB Colours. JPG, Max file size 4 MB.',
            "wrongSpecs": 'Wrong image specifications. The release cover size has to be exactly 3000 x 3000 px. JPG, Max file size 4 MB.',
            "meetsSpecs": 'Image meets all specifications.',
            "chooseImage": 'Please choose an image',
            "fileTooLarge": 'The selected file is larger than 4 MB. Please uplaod cover in 3000x3000 px, JPG, RGB colours, max file size 4 MB',
            "wrongExtension": 'Wrong file extension. The selected file has ".jpeg" extension. Please upload cover in 3000x3000 px, JPG (".jpg" extension only), RGB colours, max file size 4 MB',
        },
        "releaseTerritories": {
            "required": 'Please select territories.',
        },
        "atleastOneCountrySelected": {
            "required": 'Please select atleast one country.',
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'Youtube Content ID declaration is mandatory, please select one of the above options.',
        },
        "originalReleaseDate": {
            "required": 'Please select original release date for all shops worldwide.',
        },
        "officialReleaseDate": {
            "required": 'Please select official release date for all shops worldwide.',
        },
        "atleastOneMainArtist": {
            "required": 'At least one artist have to be main',
        },
        "featuringArtistMissing": {
            "required": 'Release must have the featured artist listed in the title correctly assigned a featured artist role. Please amend and resubmit.',
        },
        "duplicateArtists": {
            "required": 'There are two or more artists with same name.',
        },
        "artistName": {
            "required": 'Please select artist',
        },
        "artistType": {
            "required": 'Please select artist type',
        },
        "trackName": {
            "required": 'Please type track name',
        },
        "trackMixName": {
            "required": 'Please type mix name',
            "regexp": 'The mix name can only consist of alphabetical, number, space and underscore',
        }
    },
    "update": {
        "releaseName": {
            "required": 'The release name is required',
            "length": 'The release name must be more than 2 and less than 120 characters long',
            "noForwardSlash": 'The release name must not have any forward slash (/)',
            "matchTrack": 'For a one-song release the Release Name should match with the track.',
            "validCharacters": 'The release name can only consist of alphabetical, number, space and underscore'
        },
        "releaseVersion": {
            "length": 'The release version must be more than 2 and less than 120 characters long',
            "validCharacters": 'The release version can only consist of alphabetical, number, space and underscore',
            "missingOne": 'Your release consists of only one track which is not an Original Mix, therefore the custom track mix name must be inserted in the Release Version.',
            "missingTwo": 'If a release offers more content than the standard version or it is another version of already released album/release you need to insert the Release Version.',
            "invalid": 'For a one-song release with no Mix Name (Original Mix), the Release Version should be left empty. Please either clear the Release Version or add a Mix Name to the song.'
        },
        "releaseLanguage": {
            "required": 'Release Language is required. Please select the language of your release name.'
        },
        "releaseEAN_UPC": {
            "required": 'EAN / UPC is required.',
            "length": "The EAN number must be equal to 13 characters",
            "isValidEAN": "The value is not valid EAN. If you are inserting a new release, please insert a proper EAN. If you are uploading a back catalog and EAN is not valid, please contact us.",
        },
        "releaseLabel": {
            "required": 'Please select your label.'
        },
        "releaseCopyright": {
            "required": 'You have to select Copyright Owner. Usually it is your label.'
        },
        "releaseCopyrightYear": {
            "required": 'Please type the copyright year in which this release will be (was) published.',
            "regexp": 'Please type the valid copyright year'
        },
        "releaseCopyrightPublisher": {
            "required": 'You have to type Publisher Owner. Usually it is your label.'
        },
        "releaseCopyrightYearPublisher": {
            "required": 'Please type the copyright year in which this release will be (was) published.',
            "regexp": 'Please type the valid copyright year'
        },
        "releaseGenre": {
            "required": 'Please select your release Genre.'
        },
        "releaseSubGenre": {
            "required": 'Please select your release Sub-Genre'
        },
        "releaseCatalogNumber": {
            "required": 'Insert unique release catalog number.',
            "length": 'Minimum 4 and Maximum 16 characters.',
            "validFormat": 'Please insert your category number without spaces, only CAPITAL letters and numbers. First two characters are required to be CAPITAL letters. MM001, MMD001, MM0001 ...'
        },
        "releaseDescription": {
            "length": 'A release description has to be at least 100 and maximum 600 characters long.'
        },
        "releaseArtwork": {
            "required": 'The artwork is required',
            "wrongSpecsAndColor": 'Wrong image specifications and color format. The release cover size has to be exactly 3000 x 3000 px, RGB Colours, JPG, Max file size 4 MB.',
            "wrongColorFormat": 'Wrong image colour format. The release cover has to be in RGB Colours. JPG, Max file size 4 MB.',
            "wrongSpecs": 'Wrong image specifications. The release cover size has to be exactly 3000 x 3000 px. JPG, Max file size 4 MB.',
            "meetsSpecs": 'Image meets all specifications.',
            "chooseImage": 'Please choose an image',
            "fileTooLarge": 'The selected file is larger than 4 MB. Please upload cover in 3000x3000 px, JPG, RGB colours, max file size 4 MB',
            "wrongExtension": 'Wrong file extension. The selected file has ".jpeg" extension. Please upload cover in 3000x3000 px, JPG (".jpg" extension only), RGB colours, max file size 4 MB'
        },
        "releaseTerritories": {
            "required": 'Please select territories.'
        },
        "atleastOneCountrySelected": {
            "required": 'Please select at least one country.'
        },
        "atleastOneContentIDChoiceSelected": {
            "required": 'Youtube Content ID declaration is mandatory, please select one of the above options.'
        },
        "originalReleaseDate": {
            "required": 'Please select original release date for all shops worldwide.'
        },
        "officialReleaseDate": {
            "required": 'Please select official release date for all shops worldwide.'
        },
        "atleastOneMainArtist": {
            "required": 'At least one artist has to be main'
        },
        "featuringArtistMissing": {
            "required": 'Release must have the featured artist listed in the title correctly assigned a featured artist role. Please amend and resubmit.'
        },
        "duplicateArtists": {
            "required": 'There are two or more artists with same name.'
        },
        "artistName": {
            "required": 'Please select artist'
        },
        "artistType": {
            "required": 'Please select artist type'
        },
        "trackName": {
            "required": 'Please type track name'
        },
        "trackMixName": {
            "required": 'Please type mix name',
            "regexp": 'The mix name can only consist of alphabetical, number, space and underscore',
        }
    },
    "transfer": {
        "releaseName": {
            "required": "The release name is required",
            "length": "The release name must be between 2 and 120 characters",
            "invalid": "The release name cannot contain a forward slash (/)",
        },
        "releaseVersion": {
            "length": "The release version must be more than 2 and less than 120 characters long",
            "regexp": "The release version can only consist of alphabetical, number, space and underscore",
            "missingOne": "Your release consists of only one track which is not an Original Mix, therefore the custom track mix name must be inserted in the Release Version.",
            "missingTwo": "If a release offers more content than the standard version or it is another version of already released album/release you need to insert the Release Version.",
            "invalid": "For a one-song release with no Mix Name (Original Mix), the Release Version should be left empty. Please either clear the Release Version or add a Mix Name to the song.",
        },
        "releaseLanguage": {
            "required": "Release Language is required. Please select the language of your release name.",
        },
        "releaseLabel": {
            "required": "Please select your label.",
        },
        "releaseCopyright": {
            "required": "You have to type Copyright Owner. Usually it is your label.",
        },
        "releaseCopyrightYear": {
            "required": "Please type the copyright year in which this release will be (was) published.",
            "regexp": "Please type the valid copyright year",
        },
        "releaseCopyrightPublisher": {
            "required": "You have to type Publisher Owner. Usually it is your label.",
        },
        "releaseCopyrightYearPublisher": {
            "required": "Please type the copyright year in which this release will be (was) published.",
            "regexp": "Please type the valid copyright year",
        },
        "releaseGenre": {
            "required": "Please select your release Genre.",
        },
        "releaseSubGenre": {
            "required": "Please select your release Sub-Genre.",
        },
        "releaseCatalogNumber": {
            "required": "Insert unique release catalog number.",
            "length": "Minimum 4 and Maximum 16 characters.",
            "regexp": "Please insert your category number without spaces, only CAPITAL letters and numbers. First two characters are required to be CAPITAL letters. MM001, MMD001, MM0001 ... ",
        },
        "releaseDescription": {
            "length": "A release description has to be at least 100 and maximum 600 characters long.",
        },
        "releaseArtwork": {
            "required": "The artwork is required",
            "invalidDimensionsAndColorFormat": "Wrong image specifications and color format. The release cover size has to be exactly 3000 x 3000 px, RGB Colours, JPG, Max file size 4 MB.",
            "invalidColorFormat": "Wrong image colour format. The release cover has to be in RGB Colours. JPG, Max file size 4 MB.",
            "invalidDimensions": "Wrong image specifications. The release cover size has to be exactly 3000 x 3000 px. JPG, Max file size 4 MB.",
            "valid": "Image meets all specifications",
            "choose": "Please choose an image",
            "fileSize": "The selected file is larger than 4 MB. Please upload cover in 3000x3000 px, JPG, RGB colours, max file size 4 MB",
            "fileExtension": "Wrong file extension. The selected file has '.jpeg' extension. Please upload cover in 3000x3000 px, JPG ('.jpg' extension only), RGB colours, max file size 4 MB'"
        },
        "releaseTerritories": {
            "required": "Please select territories.",
        },
        "atleastOneCountrySelected": {
            "required": "Please select at least one country.",
        },
        "atleastOneContentIDChoiceSelected": {
            "required": "Youtube Content ID declaration is mandatory, please select one of the above options.",
        },
        "originalReleaseDate": {
            "required": "Please select original release date for all shops worldwide.",
        },
        "officialReleaseDate": {
            "required": "Please select official release date for all shops worldwide.",
        },
        "atleastOneMainArtist": {
            "required": "At least one artist have to be main",
        },
        "artistType": {
            "required": "Please select artist type",
        },
        "trackName": {
            "required": "Please type track name",
        },
        "trackMixName": {
            "required": "Please type mix name",
            "regexp": "The mix name can only consist of alphabetical, number, space and underscore",
        }   
    }
};
  
export default releasesValidationEN; 